/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState, useCallback } from "react";
import { modalAnatomy as parts } from "@chakra-ui/anatomy";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Divider,
} from "@chakra-ui/react";
import { useToasts } from "react-toast-notifications";

import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import "rsuite/dist/rsuite.min.css";
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from "@chakra-ui/styled-system";

import { useDispatch } from "react-redux";

import "react-datepicker/dist/react-datepicker.css";
import { fetchAsyncAddClient } from "redux/clientProjectSlice";
import { FaPlusCircle } from "react-icons/fa";
import { fetchAsyncUpdateClient } from "redux/clientProjectSlice";
import { fetchAsyncAddProject } from "redux/clientProjectSlice";
import { fetchAsyncEditProject } from "redux/clientProjectSlice";
import { fetchAsyncDeleteProject } from "redux/clientProjectSlice";
import ProjectTable from "./projectTable";
import commonJson from "../../jsonData/common.json";
import jsonData from "../../jsonData/clientProject.json";
import { GetCountries, GetState, GetCity } from "react-country-state-city";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import { InputGroup, Tab, Tabs } from "react-bootstrap";
import { CiMail } from "react-icons/ci";
import {
  ACCOUNT_NUMBER_REGEX,
  EMAIL_REGEX,
  GST_REGEX,
  IFSC_REGEX,
  MAX_GST_LENGTH,
  MAX_IFSC_LENGTH,
  MAX_PAN_LENGTH,
  PAN_REGEX,
  PHONE_REGEX,
} from "../regexPatterns";
import orgJson from "components/jsonData/orgnization.json";
import axios from "axios";
import { fetchAsyncDeleteClientBank } from "redux/clientProjectSlice";
import {
  findStateByGstCode,
  GstTreatment,
  indiaStateOptions,
} from "../Vendors/customFieldData";
import { fetchAsyncCheckClientGstIsUnique } from "redux/clientProjectSlice";
import VendorCustomSelect from "../Vendors/VendorCustomSelect";
import CustomPopover from "components/customPopover/customPopover";
import InputFormControl from "../component/inputFormControl";
import BillAndShipAddressForm from "../component/Reusable/billAndShipAddress";
import BankForm from "../component/Reusable/bankForm";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const xl = defineStyle({
  px: "6",
  py: "2",
  fontSize: "xl",
});

const sm = defineStyle({
  fontSize: "sm",
  py: "6",
});

const sizes = {
  xl: definePartsStyle({ header: sm, dialog: xl }),
};

export const modalTheme = defineMultiStyleConfig({
  sizes,
});

const ClientProject = ({
  openModal,
  closeModal,
  isEditForm = false,
  editItem,
  role,
  refreshEditData,
}) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [editData, setEditData] = useState(editItem);
  const [isEdit, setIsEdit] = useState(isEditForm);
  const [addProject, setAddProject] = useState(false);
  const [isEditProject, setIsEditProject] = useState(false);
  const [editProjectId, setEditProjectId] = useState("");
  const [activeTab, setActiveTab] = useState("");
  const [gstFields, setGstFields] = useState([
    {
      gstNo: "",
      pos: "",
    },
  ]);
  const [projectName, setProjectName] = useState("");
  const [address, setAddress] = useState({
    billingAddress: {},
    shippingAddress: {},
  });

  const [formData, setFormData] = useState({
    clientName: "",
    projects: [],
    phone: "",
    email: "",
    gstTreatment: {},
    gstNumber: "",
    panNo: "",
    bankDetails: [],
  });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.clientName)
      newErrors.clientName = jsonData.required.clientName;

    if (formData.email && !EMAIL_REGEX.test(formData.email)) {
      newErrors.email = orgJson.error.email;
    }
    if (formData.phone && !PHONE_REGEX.test(formData.phone)) {
      newErrors.phone = orgJson.error.phone;
    }
    if (formData?.panNo && !PAN_REGEX.test(formData.panNo)) {
      newErrors.panNo = orgJson.error.pan;
    }
    if (!formData?.gstTreatment?.value) {
      newErrors.gstTreatment = orgJson.required.gstTreat;
    }
    if (
      formData?.gstTreatment?.value &&
      !["Unregistered Business", "Consumer"].includes(
        formData?.gstTreatment?.value,
      )
    ) {
      gstFields.forEach((field, index) => {
        if (
          formData.gstTreatment &&
          !["Unregistered Business", "Consumer"].includes(
            formData.gstTreatment?.value,
          )
        ) {
          if (!field?.gstNo) {
            newErrors[`gstFields.${index}.gstNo`] = "GST Number is required";
          } else if (!GST_REGEX.test(field?.gstNo)) {
            newErrors[`gstFields.${index}.gstNo`] =
              "GST Number format is invalid.";
          }
        }
      });
    }

    // Validate bank details
    formData.bankDetails.forEach((bankDetail, index) => {
      if (!bankDetail.acNo) {
        newErrors[`bankDetails.${index}.acNo`] = orgJson.required.accNumber;
        if (activeTab && activeTab !== "bank") {
          addToast("Please Check Bank details!", { appearance: "error" });
        }
      } else if (!ACCOUNT_NUMBER_REGEX.test(bankDetail.acNo)) {
        newErrors[`bankDetails.${index}.acNo`] = orgJson.error.accNumber;
        if (activeTab && activeTab !== "bank") {
          addToast("Please Check Bank details!", { appearance: "error" });
        }
      }
      if (!bankDetail.ifc) {
        newErrors[`bankDetails.${index}.ifc`] = orgJson.required.ifsc;
        if (activeTab && activeTab !== "bank") {
          addToast("Please Check Bank details!", { appearance: "error" });
        }
      } else if (!IFSC_REGEX.test(bankDetail.ifc)) {
        newErrors[`bankDetails.${index}.ifc`] = orgJson.error.ifsc;
        if (activeTab && activeTab !== "bank") {
          addToast("Please Check Bank details!", { appearance: "error" });
        }
      }
    });
    if (address?.billingAddress) {
      const { phone, email } = address.billingAddress;
      if (phone && !PHONE_REGEX.test(phone)) {
        newErrors.billPhone = orgJson.error.phone;
      }
      if (email && !EMAIL_REGEX.test(email)) {
        newErrors.billEmail = orgJson.error.email;
      }
    }

    if (address?.shippingAddress) {
      const { phone, email } = address.shippingAddress;
      if (phone && !PHONE_REGEX.test(phone)) {
        newErrors.shippPhone = orgJson.error.phone;
      }
      if (email && !EMAIL_REGEX.test(email)) {
        newErrors.shippEmail = orgJson.error.email;
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddressChange = (e, type) => {
    const { name, value } = e.target;
    if (type === "billing") {
      setAddress((prev) => ({
        ...prev,
        billingAddress: {
          ...prev.billingAddress,
          [name]: value,
        },
      }));
    } else if (type === "shipping") {
      setAddress((prev) => ({
        ...prev,
        shippingAddress: {
          ...prev.shippingAddress,
          [name]: value,
        },
      }));
    }
  };

  const copyShippingAddress = (addressData) => {
    setAddress((prev) => ({
      ...prev,
      shippingAddress: prev?.billingAddress,
    }));
  };

  const handleEditData = async (editData) => {
    const { clName, prjs, ph, mail, gstTrt } = editData;
    const selGstTrt = GstTreatment.find((gst) => gst.id === gstTrt);

    setFormData({
      ...formData,
      clientName: clName,
      projects: prjs,
      phone: ph,
      gstTreatment: selGstTrt
        ? selGstTrt
        : editData?.gsts?.length
          ? GstTreatment[0]
          : {},
      email: mail,
      panNo: editData?.pnNo,
      bankDetails: editData?.bnkDtl || [],
    });
    if (editData?.add) {
      const billAdd = {
        attention: editData?.add?.atn,
        street1: editData?.add?.s1,
        street2: editData?.add.s2,
        country: {},
        state: {},
        city: {},
        pinCode: editData?.add.pin,
        phone: editData?.add.ph,
        email: editData?.add.mail,
      };
      if (editData?.add?.ctr) {
        GetCountries().then((result) => {
          billAdd.country =
            result?.find((opt) => opt.id === editData?.add?.ctr) || {};
          if (billAdd.country && billAdd?.country?.id) {
            GetState(billAdd.country.id).then((result) => {
              billAdd.state =
                result?.find((opt) => opt.id === editData?.add?.st) || {};
              if (billAdd.state && billAdd?.state?.id) {
                GetCity(billAdd.country.id, billAdd.state.id).then((result) => {
                  billAdd.city =
                    result?.find((opt) => opt.id === editData?.add?.ct) || {};
                });
              }
            });
          }
        });
      }
      setAddress((prev) => ({
        ...prev,
        billingAddress: billAdd,
      }));
    }
    if (editData?.spAd) {
      const sppAdd = {
        attention: editData?.spAd?.atn,
        street1: editData?.spAd?.s1,
        street2: editData?.spAd.s2,
        country: {},
        state: {},
        city: {},
        pinCode: editData?.spAd.pin,
        phone: editData?.spAd.ph,
        email: editData?.spAd.mail,
      };
      if (editData?.spAd?.ctr) {
        GetCountries().then((result) => {
          sppAdd.country =
            result?.find((opt) => opt.id === editData?.spAd?.ctr) || {};
          if (sppAdd.country && sppAdd?.country?.id) {
            GetState(sppAdd.country.id).then((result) => {
              sppAdd.state =
                result?.find((opt) => opt.id === editData?.spAd?.st) || {};
              if (sppAdd.state && sppAdd?.state?.id) {
                GetCity(sppAdd.country.id, sppAdd.state.id).then((result) => {
                  sppAdd.city =
                    result?.find((opt) => opt.id === editData?.spAd?.ct) || {};
                });
              }
            });
          }
        });
      }
      setAddress((prev) => ({
        ...prev,
        shippingAddress: sppAdd,
      }));
    }
    if (editData?.gsts && editData?.gsts?.length) {
      setGstFields(editData?.gsts);
    }
  };

  useEffect(() => {
    if (editData) {
      handleEditData(editData);
    }
  }, [isEdit]);

  const toCamelCase = (value) => {
    return value
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  const handleOnChange = (e) => {
    const name = e?.target?.name;
    const value = e?.target?.value;
    let formattedValue = value;
    if (name === "panNo" || name === "gstNumber") {
      formattedValue = value.toUpperCase();
      formattedValue = value.toUpperCase();
      if (name === "panNo" && formattedValue.length > MAX_PAN_LENGTH) {
        return;
      }
    } else if (name === "email") {
      formattedValue = value.toLowerCase();
      if (!formattedValue || EMAIL_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, email: "" }));
      } else {
        setErrors((prev) => ({ ...prev, email: orgJson.error.email }));
      }
    } else {
      formattedValue = toCamelCase(value);
    }
    if (name === "phone") {
      if (!formattedValue || PHONE_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, phone: "" }));
      } else {
        setErrors((prev) => ({
          ...prev,
          phone: orgJson.error.phone,
        }));
      }
    }
    if (name === "panNo") {
      if (!formattedValue || PAN_REGEX.test(formattedValue)) {
        setErrors((prev) => ({ ...prev, panNo: "" }));
      } else {
        setErrors((prev) => ({
          ...prev,
          panNo: orgJson.error.pan,
        }));
      }
    }
    if (name.startsWith("bankDetails.")) {
      const bankIndex = name.split(".")[1];
      const fieldName = name.split(".")[2];

      if (fieldName === "ifc" || fieldName === "acNo") {
        formattedValue = value.toUpperCase();
        if (fieldName === "ifc" && formattedValue.length > MAX_IFSC_LENGTH) {
          return;
        }
      }
      if (fieldName === "acNo" || fieldName === "ifc") {
        setErrors((prev) => ({
          ...prev,
          [`bankDetails.${bankIndex}.${fieldName}`]: "",
        }));
      }
      setFormData((prev) => ({
        ...prev,
        bankDetails: prev.bankDetails.map((bankDetail, index) => {
          if (index === parseInt(bankIndex)) {
            if (fieldName.startsWith("bAd.")) {
              const addressFieldName = fieldName.split(".")[2];
              return {
                ...bankDetail,
                bAd: {
                  ...bankDetail.bAd,
                  [addressFieldName]: formattedValue,
                },
              };
            } else {
              return {
                ...bankDetail,
                [fieldName]: formattedValue,
              };
            }
          }
          return bankDetail;
        }),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: formattedValue,
      }));
    }
  };

  const fetchBranchDetails = async (index) => {
    const { ifc } = formData.bankDetails[index];
    const codeToFetch = ifc;
    if (!codeToFetch) return;

    try {
      const response = await axios.get(
        `https://ifsc.razorpay.com/${codeToFetch}`,
      );
      const { BANK, BRANCH, CITY, STATE, SWIFT } = response.data;

      setFormData((prev) => ({
        ...prev,
        bankDetails: prev.bankDetails.map((bankDetail, i) => {
          if (i === index) {
            return {
              ...bankDetail,
              bnk: toCamelCase(BANK),
              bch: toCamelCase(BRANCH),
              swt: SWIFT,
              bAd: {
                ct: toCamelCase(CITY),
                st: toCamelCase(STATE),
              },
            };
          }
          return bankDetail;
        }),
      }));
    } catch (error) {
      addToast(
        "Could not fetch branch details. Please check the IFSC or MICR code.",
        { appearance: "error" },
      );
    }
  };
  const handleBlur = (index) => {
    if (IFSC_REGEX.test(formData.bankDetails[index].ifc)) {
      fetchBranchDetails(index);
    } else {
      setFormData((prev) => ({
        ...prev,
        bankDetails: prev.bankDetails.map((bankDetail, i) => {
          if (i === index) {
            return {
              ...bankDetail,
              bnk: "",
              bch: "",
              swt: "",
              bAd: {
                ct: "",
                st: "",
              },
            };
          }
          return bankDetail;
        }),
      }));
    }
  };
  const closeModelForm = () => {
    ConfirmationDialog({
      title: commonJson.close.confirm,
      text: commonJson.text.lost,
      icon: "warning",
      confirmButtonText: "Close",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        closeModal();
      },
    });
  };

  const handleIsEditProject = (projectName, projectId) => {
    setProjectName(projectName);
    setEditProjectId(projectId);
    setIsEditProject(!isEditProject);
  };

  useEffect(() => {
    if (!isEditProject) {
      setEditProjectId("");
      setProjectName("");
    }
  }, [!isEditProject]);

  const handleAddClient = () => {
    const filteredGsts = gstFields.filter((gst) => gst.gstNo.trim() !== "");

    dispatch(
      fetchAsyncAddClient({
        ...formData,
        projectName: projectName,
        billingAddress: address?.billingAddress,
        shippingAddress: address?.shippingAddress,
        gsts: filteredGsts,
      }),
    )
      .then((res) => {
        if (res?.payload) {
          const clientProject = res?.payload?.clientProject;
          handleEditData(clientProject);
          setEditData(clientProject);
          setIsEdit(true);
          setProjectName("");
          refreshEditData();
          addToast(jsonData.success.cientCreated, { appearance: "success" });
          closeModal();
        }
      })
      .catch((err) => {
        addToast(jsonData.error.generic, { appearance: "error" });
      });
  };

  const handleEditClient = () => {
    const filteredGsts = gstFields.filter((gst) => gst.gstNo.trim() !== "");

    dispatch(
      fetchAsyncUpdateClient({
        id: editData._id,
        clientData: {
          ...formData,
          billingAddress: address?.billingAddress,
          shippingAddress: address?.shippingAddress,
          gsts: filteredGsts,
        },
      }),
    )
      .then((res) => {
        if (res?.payload) {
          closeModal();
          addToast(jsonData.success.clientUpdated, { appearance: "success" });
        }
      })
      .catch((err) => {
        addToast(jsonData.error.generic, { appearance: "error" });
      });
  };

  const handleAddProject = () => {
    if (!isEdit) {
      if (validate()) {
        handleAddClient();
      }
    } else {
      dispatch(
        fetchAsyncAddProject({ id: editData._id, projectName: projectName }),
      )
        .then((res) => {
          if (res?.payload) {
            const clientProject = res?.payload?.clientProject;
            handleEditData(clientProject);
            setProjectName("");
            setErrors({});
            addToast(jsonData.success.addedd, { appearance: "success" });
          }
        })
        .catch((err) => {
          addToast(jsonData.error.addedd, { appearance: "error" });
        });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      if (!isEdit) {
        handleAddClient();
      } else {
        handleEditClient();
      }
    }
  };
  const finalRef = useRef(null);

  const handleEditProject = (e) => {
    e.preventDefault();
    dispatch(
      fetchAsyncEditProject({
        id: editData._id,
        projectId: editProjectId,
        projectName: projectName,
      }),
    )
      .then((res) => {
        if (res?.payload) {
          const clientProject = res?.payload?.clientProject;
          handleEditData(clientProject);
          setIsEditProject(false);
          setProjectName("");
          setErrors({});
          setEditProjectId("");
          addToast(jsonData.success.updated, { appearance: "success" });
        }
      })
      .catch((err) => {
        addToast(jsonData.error.updated, { appearance: "error" });
      });
  };

  const handleDeleteProject = (projectId) => {
    dispatch(
      fetchAsyncDeleteProject({ id: editData._id, projectId: projectId }),
    )
      .then((res) => {
        if (res?.payload) {
          const clientProject = res?.payload?.clientProject;
          handleEditData(clientProject);
          addToast(jsonData.success.deleted, { appearance: "success" });
        }
      })
      .catch((err) => {
        addToast(jsonData.error.deleted, { appearance: "error" });
      });
  };

  const handleAddProjectBtn = (e) => {
    if (addProject && !projectName) {
      setErrors({
        ...errors,
        projectName: jsonData.required.project,
      });
    } else {
      if (!isEditProject) {
        handleAddProject(e);
      } else {
        handleEditProject(e);
      }
    }
  };
  const addBankDetail = () => {
    setFormData((prev) => ({
      ...prev,
      bankDetails: [
        ...prev.bankDetails,
        {
          hol: "",
          bnk: "",
          bch: "",
          ifc: "",
          swt: "",
          acNo: "",
          typ: 0,
          bAd: {
            ct: "",
            st: "",
          },
        },
      ],
    }));
  };
  const handleSelectTab = (k) => {
    setActiveTab(k);
  };

  const removeBankDetail = (index) => {
    if (isEdit) {
      ConfirmationDialog({
        title: orgJson.confirm.delete,
        text: orgJson.text.undone,
        icon: "warning",
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        onConfirm: () => {
          dispatch(fetchAsyncDeleteClientBank(editData?._id, index)).then(
            (res) => {
              if (res?.payload) {
                addToast(orgJson.success.deletedBank, {
                  appearance: "success",
                });
                setFormData((prev) => ({
                  ...prev,
                  bankDetails: prev.bankDetails.filter(
                    (bankDetail, i) => i !== index,
                  ),
                }));
              }
            },
          );
        },
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        bankDetails: prev.bankDetails.filter((bankDetail, i) => i !== index),
      }));
    }
  };

  const checkGstNumberIsUnique = async (data) => {
    try {
      const res = await dispatch(fetchAsyncCheckClientGstIsUnique(data));
      return res?.payload?.unique ?? false;
    } catch (err) {
      addToast(orgJson.error.generic, { appearance: "error" });
      return false;
    }
  };
  const handleGstChange = async (index, value) => {
    const newGstFields = [...gstFields];
    const formattedValue = value.toUpperCase();
    if (formattedValue.length > MAX_GST_LENGTH) {
      return;
    }
    let state = {};
    if (GST_REGEX.test(formattedValue)) {
      const isDuplicate = newGstFields.some(
        (field, idx) => field.gstNo === formattedValue && idx !== index,
      );
      if (isDuplicate) {
        addToast("GST Number already exists!", {
          appearance: "error",
        });
        return;
      }
      const data = {
        gstNo: formattedValue,
        clientId: editData?._id || null,
      };
      // Check if the GST number is unique
      const isUnique = await checkGstNumberIsUnique(data);
      if (!isUnique) {
        addToast("This GST number is already registered.!", {
          appearance: "error",
        });
        return;
      }
      const extractedPan = formattedValue.substring(2, 12);

      const stateCode = formattedValue.substring(0, 2);
      state = findStateByGstCode(stateCode) || "";
      setFormData((prev) => ({
        ...prev,
        panNo: extractedPan,
      }));
    }
    if (!formattedValue || GST_REGEX.test(formattedValue)) {
      setErrors((prev) => ({ ...prev, [`gstFields.${index}.gstNo`]: "" }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [`gstFields.${index}.gstNo`]: "GST Number format is invalid.",
      }));
    }
    const isState = newGstFields.some(
      (field, idx) => field.placeOfSupply === state.value && idx !== index,
    );

    if (isState) {
      state = {};
    }
    newGstFields[index] = {
      gstNo: formattedValue,
      pos: state?.value,
    };
    setGstFields(newGstFields);
  };

  const handlePosChange = (index, value) => {
    const isDuplicate = gstFields.some(
      (field, idx) => field.pos === value && idx !== index,
    );
    if (isDuplicate) {
      const newGstFields = gstFields.map((gstField, i) => {
        if (i === index) {
          return {
            ...gstField,
            pos: "",
          };
        }
        return gstField;
      });
      addToast("Place Of Supply already exists!", {
        appearance: "error",
      });

      setGstFields(newGstFields);
    } else {
      const newGstFields = gstFields.map((gstField, i) => {
        if (i === index) {
          return {
            ...gstField,
            pos: value || "",
          };
        }
        return gstField;
      });

      setGstFields(newGstFields);
    }
  };

  useEffect(() => {
    if (
      formData?.gstTreatment &&
      ["Unregistered Business", "Consumer"].includes(
        formData?.gstTreatment?.value,
      )
    ) {
      setGstFields([
        {
          gstNo: "",
          pos: "",
        },
      ]);
    }
  }, [formData.gstTreatment]);
  const addGstField = () => {
    setGstFields([
      ...gstFields,
      {
        gstNo: "",
        pos: "",
      },
    ]);
  };
  const findStateByName = useCallback((stateName) => {
    return indiaStateOptions.find((state) => state.label === stateName);
  }, []);

  const removeGstField = (index) => {
    const newGstFields = gstFields.filter((_, i) => i !== index);
    setGstFields(newGstFields);
  };
  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={openModal}
        onClose={closeModelForm}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent
          top="0" // Position it at the top
          margin="0 auto" // Center it horizontally
          bottom="0"
          className="add-form-modal-content"
        >
          <div className="fixed-header">
            <ModalHeader className="expense-modal-header">
              {isEdit && "Edit"} Client & Projects{" "}
            </ModalHeader>
            <ModalCloseButton />
          </div>
          <ModalBody>
            <Form className="addForm">
              <div className="form-card">
                <h5>Personal Details</h5>
                <Row>
                  <Col>
                    <Box display="flex" className="input-box">
                      <Form.Label>
                        Company / Client name{" "}
                        <span className="span-star">*</span>
                      </Form.Label>
                      <InputFormControl
                        name="clientName"
                        placeholder="Enter Client Name"
                        value={formData?.clientName}
                        handleChange={(e) => handleOnChange(e)}
                        isInvalid={!!errors.clientName}
                      />
                    </Box>
                    <p className="form_error">{errors.clientName}</p>
                  </Col>
                  <Col></Col>
                </Row>
                <Row>
                  <Col>
                    <Box display="flex" className="input-box">
                      <Form.Label>Phone</Form.Label>
                      <InputFormControl
                        type="Number"
                        name="phone"
                        value={formData?.phone || ""}
                        handleChange={(e) => handleOnChange(e)}
                        placeholder="Enter Phone"
                        groupText1={
                          <InputGroup.Text className="country-code">
                            {formData?.address?.country?.phone_code}
                          </InputGroup.Text>
                        }
                      />
                    </Box>
                    {errors?.phone && (
                      <p className="form_error">{errors?.phone}</p>
                    )}
                  </Col>
                  <Col>
                    <Box display="flex" className="input-box">
                      <Form.Label>Email</Form.Label>
                      <InputFormControl
                        name="email"
                        value={formData?.email || ""}
                        handleChange={(e) => handleOnChange(e)}
                        groupText1={
                          <InputGroup.Text id="basic-addon1">
                            <CiMail />
                          </InputGroup.Text>
                        }
                      />
                    </Box>
                    {errors?.email && (
                      <p className="form_error">{errors?.email}</p>
                    )}
                  </Col>
                </Row>
                <div className="form-card mt-1">
                  <Box display="flex" alignItems="center">
                    <h5>Project Details</h5>
                    <Button
                      className="add-project mt-1 mx-1"
                      onClick={() => {
                        setAddProject(!addProject);
                      }}
                    >
                      <FaPlusCircle className="add-project-icon" size={15} />
                    </Button>
                  </Box>
                  {(addProject || isEditProject) && (
                    <Row>
                      <Col>
                        <Box display="flex" className="input-box" width={580}>
                          <Form.Label>Project Name </Form.Label>
                          <InputFormControl
                            name="projectName"
                            placeholder="Enter Project Name"
                            value={projectName}
                            handleChange={(e) =>
                              setProjectName(e?.target?.value)
                            }
                            isInvalid={!!errors.projectName}
                          />
                          <Box className="mx-1">
                            <Button
                              variant="brand"
                              className="add-project-btn px-4"
                              size="sm"
                              onClick={(e) => handleAddProjectBtn(e)}
                            >
                              {isEditProject ? "Edit" : "Add"}
                            </Button>
                          </Box>
                        </Box>
                        <p className="form_error">{errors.projectName}</p>
                      </Col>
                    </Row>
                  )}
                  {formData?.projects && formData?.projects?.length > 0 && (
                    <ProjectTable
                      projects={formData?.projects}
                      onEditProject={(prj, _id) => {
                        handleIsEditProject(prj, _id);
                      }}
                      onDeleteProject={(_id) => handleDeleteProject(_id)}
                    />
                  )}
                </div>
              </div>

              <Divider className="mt-3" />
              <div>
                <Tabs
                  // defaultActiveKey="otherDetails"
                  defaultActiveKey={activeTab ? activeTab : "taxDetails"}
                  transition={false}
                  id="noanim-tab-example"
                  className="add-form-tabs"
                  onSelect={handleSelectTab}
                >
                  <Tab
                    eventKey="taxDetails"
                    title="Tax Details"
                    className="add-form-tab mx-0"
                  >
                    <div>
                      <Row>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>
                              GST Treatment <span className="span-star">*</span>
                            </Form.Label>
                            <VendorCustomSelect
                              options={GstTreatment}
                              placeHolder=""
                              onChange={(newValue) => {
                                console.log(newValue, "values");
                                setFormData({
                                  ...formData,
                                  gstTreatment: newValue,
                                });
                              }}
                              isSearchable
                              isInvalid={
                                !formData?.gstTreatment && !!errors.gstTreatment
                              }
                              defaultValue={formData?.gstTreatment}
                            />
                          </Box>
                          {!formData?.gstTreatment?.value && (
                            <p className="form_error">{errors?.gstTreatment}</p>
                          )}
                        </Col>
                        <Col></Col>
                      </Row>
                      {formData?.gstTreatment?.value &&
                        !["Unregistered Business", "Consumer"].includes(
                          formData?.gstTreatment?.value,
                        ) && (
                          <Row>
                            <Col>
                              <Box display="flex" className="input-box">
                                <Row>
                                  <Col>
                                    <Form.Label>
                                      GSTIN / UIN{" "}
                                      <span className="span-star">*</span>
                                      <Button
                                        className="add-vendor-gst"
                                        onClick={(e) => addGstField()}
                                      >
                                        +
                                      </Button>
                                    </Form.Label>
                                  </Col>
                                  <Col>
                                    <Box className="multiple-gst-field">
                                      {gstFields.map((gst, index) => {
                                        const defaultValue = gst?.pos
                                          ? findStateByName(gst.pos)
                                          : null;
                                        return (
                                          <div className="gst-fields-div">
                                            <InputFormControl
                                              name="gstFields"
                                              placeholder="GST Number"
                                              value={gst?.gstNo || ""}
                                              handleChange={(e) =>
                                                handleGstChange(
                                                  index,
                                                  e.target.value,
                                                )
                                              }
                                              isInvalid={
                                                !!errors[
                                                  `gstFields.${index}.gstNo`
                                                ]
                                              }
                                            />
                                            <VendorCustomSelect
                                              options={indiaStateOptions}
                                              placeHolder="Place Of Supply"
                                              onChange={(newValue) =>
                                                handlePosChange(
                                                  index,
                                                  newValue?.value,
                                                )
                                              }
                                              isSearchable
                                              isDisabled={!gst?.gstNo}
                                              defaultValue={defaultValue || ""}
                                            />
                                            <button
                                              disabled={index === 0}
                                              className="gst-remove-btn"
                                              onClick={(e) =>
                                                removeGstField(index)
                                              }
                                            >
                                              X
                                            </button>
                                          </div>
                                        );
                                      })}
                                    </Box>
                                  </Col>
                                </Row>
                              </Box>
                            </Col>
                          </Row>
                        )}
                      <Row>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>
                              PAN
                              <CustomPopover popoverText="Please note that you can change the PAN number according to any one GST number. Ensure that the PAN number is correct." />
                            </Form.Label>
                            <Box display="flex">
                              <InputFormControl
                                name="panNo"
                                placeholder="PAN Number"
                                value={formData.panNo}
                                handleChange={(e) => handleOnChange(e)}
                                isInvalid={!!errors.panNo}
                              />
                            </Box>
                          </Box>
                          <p className="form_error">{errors?.panNo}</p>
                        </Col>
                        <Col></Col>
                      </Row>
                    </div>
                  </Tab>
                  <Tab
                    eventKey="address"
                    title="Address"
                    className="add-form-tab mx-0"
                  >
                    <BillAndShipAddressForm
                      handleAddress={(e, type) => handleAddressChange(e, type)}
                      addressData={address}
                      copyShippingAdd={(obj) => copyShippingAddress(obj)}
                      errors={errors}
                    />
                  </Tab>
                  <Tab
                    eventKey="bank"
                    title="Bank Details"
                    className="add-form-tab mx-0"
                  >
                    {formData?.bankDetails &&
                      formData?.bankDetails?.length > 0 &&
                      formData?.bankDetails.map((bankDetail, index) => (
                        <BankForm
                          bankDetail={bankDetail}
                          index={index}
                          removeBankDetail={removeBankDetail}
                          handleChange={handleOnChange}
                          handleBlur={handleBlur}
                          errors={errors}
                          companyName={formData?.clientName}
                        />
                      ))}
                    <div className="form-card mt-1">
                      <Box
                        display="flex"
                        alignItems="center"
                        onClick={addBankDetail}
                      >
                        <h5>Add Bank</h5>

                        <Button className="add-project mt-2">
                          <FaPlusCircle
                            className="add-project-icon"
                            size={15}
                          />
                        </Button>
                      </Box>
                    </div>
                  </Tab>
                </Tabs>
              </div>
              <ModalFooter className="mt-4">
                <Button
                  type="submit"
                  className="submit-btn"
                  variant="brand"
                  style={{ background: "#191063" }}
                  onClick={(e) => handleSubmit(e)}
                >
                  Submit
                </Button>
              </ModalFooter>
            </Form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ClientProject;
